import { useState } from 'react'
import { useEffect } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { Button, Stack, Paper, TableContainer } from '@mui/material'
import { Item } from '../../../common/snippets'
import {
  paymentWiseColumns,
  excelHeader,
  groupData,
  paymentWiseAddTotal,
  headerColumns,
  SNCol,
  sourceCityCol,
  sourceBranchCol,
  destCityCol,
  destBranchCol,
  addTotal,
  reportOptionSum,
} from './constants'
import { useSelector } from 'react-redux'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { useAtom } from 'jotai'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { RenderTable } from './summmaryTable'
import { makeTable } from './pdfAutotable'
import { totalPagesExp, xlCol } from '../../../common/constants'
import { exportToExcel } from '../../../common/hook'
import { divideInNIntegers } from '../../../common/mathHelper'
const reportname = 'Analysis Report'
const SummaryReport = (props) => {
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID, UseToPayAsCOD } = companySettings
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel } = { ...roleRightsData }
  const { BookingDateWise, headerData, tableData, reportOptions } = props
  const { loginData } = useSelector((state) => state?.common)
  const [paymentWiseTable, setPaymentWiseTable] = useState([])
  const [sourceCityTable, setSourceCityTable] = useState([])
  const [sourceBranchTable, setSourceBranchTable] = useState([])
  const [destCityTable, setDestCityTable] = useState([])
  const [destBranchTable, setDestBranchTable] = useState([])
  const [bookingDateWiseTable, setBookingDateWiseTable] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const paymentWiseCol =
    DefaultCurrencyID === 2
      ? paymentWiseColumns.map((col) => (col.field === 'Valuation' ? { ...col, headerName: 'Insurance' } : col))
      : paymentWiseColumns
  const paymentHeader = [...paymentWiseCol]
  const updatedHeaderColumns =
    UseToPayAsCOD === 1
      ? headerColumns
          .map((col) => {
            switch (col.field) {
              case 'TotalToPay':
                return { ...col, headerName: 'COD', exportHead: 'COD' }
              case 'TotalToPayMan':
                return { ...col, headerName: 'COD Manual', exportHead: 'COD Manual' }
              case 'TotalToPayDDDV':
                return { ...col, headerName: 'COD DDDV', exportHead: 'COD DDDV' }
              default:
                return col
            }
          })
          .filter((col) => col.field !== 'TotalCOD')
      : headerColumns
  const sourceCityHeader = [SNCol, sourceCityCol, ...updatedHeaderColumns]
  const sourceBranchHeader = [SNCol, sourceCityCol, sourceBranchCol, ...updatedHeaderColumns]
  const destCityHeader = [SNCol, destCityCol, ...updatedHeaderColumns]
  const destBranchHeader = [SNCol, destCityCol, destBranchCol, ...updatedHeaderColumns]
  const bookingDateWiseHeader = [...paymentWiseCol]
  const [tableList, setTableList] = useState({})

  const span1 = divideInNIntegers(destBranchHeader.length, 2)

  const header1 = [
    [
      { header: `Report For: ${reportname} Report`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  const excelHeaders = [excelHeader]
  const excelData = [[headerData]]
  const headerObject = {
    textAlign: 'left',
    field: '',
    span: paymentHeader.length,
    mainHeader: true,
    skipSpace: true,
  }
  if (tableList?.[1]) {
    excelHeaders.push([[{ header: reportOptionSum[1].Option, ...headerObject }]])
    excelData.push([])

    excelHeaders.push(paymentHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(paymentWiseTable)
  }
  if (tableList?.[2]) {
    excelHeaders.push([[{ header: reportOptionSum[2].Option, ...headerObject }]])
    excelData.push([])

    excelHeaders.push(sourceCityHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(sourceCityTable)
  }

  if (tableList?.[3]) {
    excelHeaders.push([[{ header: reportOptionSum[3].Option, ...headerObject }]])
    excelData.push([])

    excelHeaders.push(sourceBranchHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(sourceBranchTable)
  }

  if (tableList?.[4]) {
    excelHeaders.push([[{ header: reportOptionSum[4].Option, ...headerObject }]])
    excelData.push([])

    excelHeaders.push(destCityHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(destCityTable)
  }

  if (tableList?.[5]) {
    excelHeaders.push([[{ header: reportOptionSum[5].Option, ...headerObject }]])
    excelData.push([])

    excelHeaders.push(destBranchHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(destBranchTable)
  }

  if (tableList?.[6]) {
    excelHeaders.push([[{ header: reportOptionSum[6].Option, ...headerObject }]])
    excelData.push([])
    excelHeaders.push(bookingDateWiseHeader.map((a) => ({ ...a, header: a.headerName, textAlign: a.align || 'left' })))
    excelData.push(bookingDateWiseTable)
  }
  if (DefaultCurrencyID === 2) {
    const index = paymentHeader.findIndex((item) => item.field === 'ServiceTax')
    if (index !== -1) {
      paymentHeader.splice(index, 1)
      bookingDateWiseHeader.splice(index, 1)
    }
  }
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  useEffect(() => {
    if (Object.keys(tableData).length) {
      if (reportOptions.find((a) => a.optionId === 1) || reportOptions?.[0]?.optionId === 0) {
        setPaymentWiseTable(
          paymentWiseAddTotal(
            tableData.Table1.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
            headerData,
            'TOTAL: All Payment Types',
            paymentHeader
          )
        )
        setTableList((prev) => ({ ...prev, 1: true }))
      }
      if (reportOptions.find((a) => a.optionId === 2) || reportOptions?.[0]?.optionId === 0) {
        setSourceCityTable(
          addTotal(
            tableData.Table2.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
            headerData,
            'TOTAL: All Source Cities',
            sourceCityHeader
          )
        )
        setTableList((prev) => ({ ...prev, 2: true }))
      }
      if (reportOptions.find((a) => a.optionId === 3) || reportOptions?.[0]?.optionId === 0) {
        setSourceBranchTable(
          addTotal(
            tableData.Table3.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
            headerData,
            'TOTAL: All Source Branches',
            sourceBranchHeader
          )
        )
        setTableList((prev) => ({ ...prev, 3: true }))
      }
      if (reportOptions.find((a) => a.optionId === 4) || reportOptions?.[0]?.optionId === 0) {
        setDestCityTable(
          addTotal(
            tableData.Table4.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
            headerData,
            'TOTAL: All Destination Cities',
            destCityHeader
          )
        )
        setTableList((prev) => ({ ...prev, 4: true }))
      }
      if (reportOptions.find((a) => a.optionId === 5) || reportOptions?.[0]?.optionId === 0) {
        setDestBranchTable(
          addTotal(
            tableData.Table5.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
            headerData,
            'TOTAL: All Dest. Branches',
            destBranchHeader
          )
        )
        setTableList((prev) => ({ ...prev, 5: true }))
      }
      if (reportOptions.find((a) => a.optionId === 6) || reportOptions?.[0]?.optionId === 0) {
        let bookingWisedata = tableData?.Table6?.map((item) => ({
          ...item,
          dataType: 'entry',
          BookingDate: item.BookingDateTime?.split('T')?.[0],
        }))
        const updatedArray = groupData('BookingDate', bookingWisedata, headerData, bookingDateWiseHeader)
        setBookingDateWiseTable(updatedArray)
        setTableList((prev) => ({ ...prev, 6: true }))
      }
    }
  }, [tableData, reportOptions])

  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = excelHeader.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    const pdfFontSize = 1
    doc.setProperties({
      title: `Analysis Reports.pdf`,
      subject: 'Analysis  Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(18).setFont('Roboto', 'bold')
      doc.text(`Booking Date: ${headerData.fromDate}  To  ${headerData.toDate} `, data.settings.margin.left, 150)
      doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
    }
    makeTable(doc, autoTable, HeaderColumns, [headerData], pdfFontSize, reportname, loginData, 'everyPage', customFunction, 160)
    if (tableList?.[1]) {
      const header = paymentHeader.map((col) => {
        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[1].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, paymentWiseTable, pdfFontSize, reportname, loginData)
    }
    if (tableList?.[2]) {
      const header = sourceCityHeader.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[2].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, sourceCityTable, pdfFontSize, reportname, loginData)
    }
    if (tableList?.[3]) {
      const header = sourceBranchHeader.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[3].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, sourceBranchTable, pdfFontSize, reportname, loginData)
    }
    if (tableList?.[4]) {
      const header = destCityHeader.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[4].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, destCityTable, pdfFontSize, reportname, loginData)
    }
    if (tableList?.[5]) {
      const header = destBranchHeader.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[5].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, destBranchTable, pdfFontSize, reportname, loginData)
    }
    if (tableList?.[6]) {
      const header = bookingDateWiseHeader.map((col) => {
        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
      })
      const afterTableY = doc.lastAutoTable.finalY
      doc.text(reportOptionSum[6].Option, 30, afterTableY + 30)
      makeTable(doc, autoTable, header, bookingDateWiseTable, pdfFontSize, reportname, loginData)
    }
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaPaymentWiseOutput').data = pdfUrl
      // document.getElementById('anaPaymentWiseOutput').data = doc.output('datauristring', ' Analysis Reports.pdf')
      focusElemnt('backBtn')
    }, 1000)
    if (isSave) {
      doc.save(`${reportname} ${currentDateTime}.pdf`)
    }
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">
            Report For: Analysis Report - {BookingDateWise ? 'Booking Date Wise Summary Report' : 'Payment Type Wise Summary Report'}
          </Item>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `Analysis Report ${currentDateTime}.xlsx`,
                        sheetName: 'Analysis Report',
                        headersList: [header1, ...excelHeaders],
                        dataList: [[], ...excelData],
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>

                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'analPrintBtn', !AllowExportExcel ? id.anSplitButton : 'analsExpToExlbtn', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                    id="anaxportAsPdfBtn"
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)

                      printClick(false)
                    }}
                    id="analPrintBtn"
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, 'anaxportAsPdfBtn', () => {
                        setSearchResult(true)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, id.anSplitButton, () => {
                        setSearchResult(true)
                        focusElemnt(id.anSplitButton)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
          <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: '6px' }}>
            {tableList?.[1] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[1].Option}</Box>
                <RenderTable header={paymentHeader} data={paymentWiseTable} key1={'fdierm'} key2={'sdiew'} key3={'orwex3'} />
              </>
            )}
            {tableList?.[2] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[2].Option}</Box>
                <RenderTable header={sourceCityHeader} data={sourceCityTable} key1={'fdorew'} key2={'f9423'} key3={'f043d'} />
              </>
            )}
            {tableList?.[3] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[3].Option}</Box>
                <RenderTable header={sourceBranchHeader} data={sourceBranchTable} key1={'vcorkw95'} key2={'df043d'} key3={'405f9ss'} />
              </>
            )}
            {tableList?.[4] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[4].Option}</Box>
                <RenderTable header={destCityHeader} data={destCityTable} key1={'fjer94'} key2={'fdk45s'} key3={'firi4'} />
              </>
            )}
            {tableList?.[5] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[5].Option}</Box>
                <RenderTable header={destBranchHeader} data={destBranchTable} key1={'0erm43'} key2={'fgin23or'} key3={'fmre0sd34'} />
              </>
            )}

            {tableList?.[6] && (
              <>
                <Box sx={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'left', paddingLeft: '17px' }}>{reportOptionSum[6].Option}</Box>
                <RenderTable
                  header={bookingDateWiseHeader}
                  data={bookingDateWiseTable}
                  key1={'dsmfdk45kfd'}
                  key2={'fidfir03'}
                  key3={'dfkerk5'}
                />
              </>
            )}
          </TableContainer>
        </Stack>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="anaPaymentWiseOutput"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default SummaryReport
